import React, { ReactNode } from 'react';
import GoogleAnalyticsConstants from '~/constants/google-analytics-constants';

interface Props {
  /**
   * Label content
   */
  children: ReactNode;
  /**
   * Used for google analytics
   */
  trackingLabel: string;
  /**
   * Used to support automated testing querying  by id
   */
  id: string;
}

const MenuLabel = ({ children, trackingLabel, id }: Props) => {
  return (
    <span
      data-trackingcategory={GoogleAnalyticsConstants.categories.MENU_LINK}
      data-trackingaction={GoogleAnalyticsConstants.actions.NAVIGATE}
      data-trackinglabel={trackingLabel}
      id={id}
    >
      {children}
    </span>
  );
};

export default MenuLabel;
